module.exports = "/_next/static/images/BG_BG-7e3e5a622d4aaca0de8ace63f3995b09.png";